import { filterRequest } from "mappers";
import * as moment from "moment";
import { toApiDateTimeFormat } from "services/date.service";

import {
  dateToTimeAgo
} from "./common.mapper";

export const mdmListResponse = {
  deviceName: {
    key: "deviceName",
  },
  deviceImei: {
    key: "deviceImei",
  },
  model: {
    key: "model",
  },
  venueName: {
    key: "venueName",
  },
  longitude: {
    key: "longitude",
  },
  latitude: {
    key: "latitude",
  },
  osVersion: {
    key: "osVersion",
  },
  firmwareVersion: {
    key: "firmwareVersion",
  },
  softwareVersion: {
    key: "softwareVersion",
  },
  ghlVersion: {
    key: "ghlVersion",
  },
  ttbVersion: {
    key: "ttbVersion",
  },
  userDetails: {
    key: "userDetails",
  },
  deviceRegisterDateTime:  dateToTimeAgo("deviceRegisterDateTime"),
  deviceLastLocationDateTime:  dateToTimeAgo("deviceLastLocationDateTime"),
};


const dateTimeRequestV2 = {
  filterFromDate: {
    transform: ({ src }) => {
      if (!src?.dateRange?.[0]) return moment().startOf("day").format("YYYY-MM-DDTHH:mm:ss");
      return moment(src?.dateRange?.[0]).format("YYYY-MM-DDTHH:mm:ss");
    },
  },
  filterToDate: {
    transform: ({ src }) => {
      if (!src?.dateRange?.[1]) return moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss");
      return moment(src?.dateRange?.[1]).format("YYYY-MM-DDTHH:mm:ss");
    },
  },
};

export const dateTimeRequest = {
  filterFromDate: {
    transform: ({ src }) => {
      if (!src?.dateRange?.[0]) return toApiDateTimeFormat(moment().startOf("day"));
      return toApiDateTimeFormat(src?.dateRange?.[0]);
    },
  },
  filterToDate: {
    transform: ({ src }) => {
      if (!src?.dateRange?.[1]) return toApiDateTimeFormat(moment().endOf("day"));
      return toApiDateTimeFormat(src?.dateRange?.[1], true);
    },
  },
};



export const mdmListRequest = {
  ...filterRequest,
  ...dateTimeRequestV2
};

